import { ArrowBackIos } from '@mui/icons-material';
import { Box, IconButton, Breakpoint, Grid } from '@mui/material';
import SearchBar from 'src/components/SearchBar/SearchBar';
import { FlexContainer } from 'src/components/styles';

interface SearchBarInputProps {
  onBack: () => void;
  columns?: { [key in Breakpoint]?: number };
  autoFocus?: boolean;
}

const SearchBarInput = ({
  onBack,
  columns,
  autoFocus = true,
}: SearchBarInputProps) => {
  const columnBreakpoints = columns ?? {
    xs: 10,
    sm: 11,
    md: 5,
    xl: 4,
  };

  return (
    <Grid item {...columnBreakpoints}>
      <FlexContainer
        width="100%"
        pr={{ md: 1 }}
        pl={{ xs: 1, md: 0 }}
        justifyContent="space-between"
        alignItems="center"
      >
        <IconButton onClick={onBack} size="small" sx={{ p: 0 }}>
          <ArrowBackIos />
        </IconButton>
        <Box width={{ xs: '90%', sm: '91%' }}>
          <SearchBar autoFocus={autoFocus} />
        </Box>
      </FlexContainer>
    </Grid>
  );
};

export default SearchBarInput;
